const GUEST_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/;

export const normalizeGuestEmail = value =>
  String(value || '')
    .trim()
    .toLowerCase();

export const isValidGuestEmail = value =>
  GUEST_EMAIL_PATTERN.test(normalizeGuestEmail(value));
